export const rovers = [
    {
        name: 'Curiosity',
        link: 'curiosity'
    },
    {
        name: 'Opportunity',
        link: 'opportunity'
    },
    {
        name: 'Spirit',
        link: 'spirit'
    },
]